import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=0e244fdf&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=0e244fdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e244fdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e244fdf')) {
      api.createRecord('0e244fdf', component.options)
    } else {
      api.reload('0e244fdf', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=0e244fdf&scoped=true&", function () {
      api.rerender('0e244fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUh9a3P9PJMR/JS/pricehelp.vue"
export default component.exports